export type ConnectionSettingResponse = {
  id: string;
  name: string | null;
  clientId: string | null;
  schemeId: string | null;
  companyId: string;
  companyName: string | null;
  updatedByName: string | null;
  createdDate: string;
  updatedDate: string | null;
};

export type ConnectionSettingDetailsResponse = ConnectionSettingResponse & {
  clientSecret: string | null;
};

export type CreateConnectionSettingModel = {
  name: string;
  companyId: string;
  schemeId?: string;
};

export type DataGatewayCompanyResponse = {
  id: string;
  name: string;
};

export type DataGatewaySchemeResponse = {
  id: string;
  name: string;
  companyId: string;
};

export type CreateIpRecordModel = {
  ip: string;
  description?: string;
};

export type UpdateIpRecordModel = CreateIpRecordModel & {
  id: string;
};

export type ConnectionIpWhiteListResponse = {
  id: string;
  ip: string;
  description: string | null;
  createdDate: string;
  updatedDate: string | null;
};

export type UpdateConnectionPermissionModel = {
  read: boolean;
  write: boolean;
};

export type ModuleResponse = UpdateConnectionPermissionModel & {
  id: string;
  name: string;
  logoUrl: string;
};

export type ModulePermissionModel = UpdateConnectionPermissionModel & {
  moduleId: string;
};

export type ConnectionPermissionResponse = UpdateConnectionPermissionModel & {
  id: string;
  moduleId: string;
  connectionSettingId: string;
  createdDate: string;
  updatedDate: string;
};

export type ThirdPartyPlatformSettingSearchResponse = {
  id: string;
  name: string | null;
  createdDate: string;
  updatedById: string;
  updatedByName: string | null;
  updatedDate: string | null;
  companyName: string | null;
  appName?: ThirdPartyPlatformSettingApp;
};

export type ThirdPartyPlatformSettingSearchResponsePagedResponse = {
  totalCount: number;
  items: ThirdPartyPlatformSettingSearchResponse[] | null;
};

export type CompanyDto = {
  id: string;
  isDefault: boolean;
  schemeIds?: string[];
};

export enum ThirdPartyPlatformSettingApp {
  PenScope = 'PenScope',
  LumeraCore = 'LumeraCore',
}
export enum AuthType {
  Basic = 'Basic',
  Bearer = 'Bearer',
}

export type CreateThirdPartyPlatformSettingDto = {
  name: string;
  appName: ThirdPartyPlatformSettingApp;
  authType: AuthType;
  authUrl?: string;
  apiUrl: string;
  clientId: string;
  clientSecret: string;
  company: CompanyDto;
};

export type UpdateThirdPartyPlatformSettingDto = Omit<CreateThirdPartyPlatformSettingDto, 'company'>;

export type ThirdPartyPlatformCompanyResponse = {
  id: string;
  name: string;
  hasDefaultSetting: boolean;
  schemes: DataGatewaySchemeResponse[] | null;
};

export type ThirdPartyPlatformSettingResponse = {
  id: string;
  name: string | null;
  appName: ThirdPartyPlatformSettingApp;
  authType: AuthType;
  authUrl: string | null;
  apiUrl: string | null;
  clientId: string | null;
  clientSecret: string | null;
  createdDate: string;
  updatedById: string;
  updatedByName: string | null;
  updatedDate: string | null;
  isDefault: boolean;
  company: DataGatewayCompanyResponse;
  schemes: DataGatewaySchemeResponse[] | null;
};
